import { lockBodyScroll } from '@/scripts/tools/utilities';

document.addEventListener('alpine:init', () => {
  Alpine.data('splashScreen', () => ({
    isVisible: true,
    progress: 0,

    init() {
      if (sessionStorage.getItem('splashScreen')) {
        this.isVisible = false;
        this.$el.remove();
        document.body.classList.remove('splash-loading');
        return;
      } else {
        this.$el.classList.remove('splash-screen--disabled');
        document.body.classList.remove('splash-loading');
      }

      Promise.all([
        document.fonts.ready,
        new Promise(resolve => setTimeout(resolve, 100)),
      ]).then(() => {
        this.simulateLoading();
      });
    },

    lockBodyScroll() {
      lockBodyScroll(this.isVisible);
    },

    simulateLoading() {
      const interval = setInterval(() => {
        this.progress += Math.random() * 15;

        if (this.progress >= 100) {
          this.progress = 100;
          clearInterval(interval);
          this.hide();
        }

        this.updateLoaderBar();
      }, 100);

      // Fallback: hide after maximum time
      setTimeout(() => {
        this.progress = 100;
        this.updateLoaderBar();
        this.hide();
      }, 3000);
    },

    updateLoaderBar() {
      if (this.$refs.loaderBar) {
        this.$refs.loaderBar.style.width = `${this.progress}%`;

        if (this.progress >= 100) {
          this.$refs.loader.classList.add('splash-screen__loader--hidden');
        }
      }
    },

    hide() {
      return new Promise((resolve) => {
        const hideSplashScreen = () => {
          this.isVisible = false;
          sessionStorage.setItem('splashScreen', 'true');
          document.body.classList.remove('splash-loading');
          resolve();
        };

        // Check if the loader:end event has already been emitted
        // If the event has already been emitted, hide immediately
        // Otherwise, wait for the event
        if (window.__loaderEndEmitted === true) {
          hideSplashScreen();
        } else {
          window.addEventListener('loader:end', hideSplashScreen, { once: true });
        }
      });
    },
  }));
});

